import React, { useState, useEffect, useRef } from "react";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Swal from "sweetalert2";
import { toast } from "react-toastify"; // New import for toast notifications
import { useMenuModalStates } from "../../../hooks/use-menu-modal-states"; // New import for modal states
import MenuModal from "../../../components/tools/menu-modal"; // New import for menu modal
import AppointmentStatusHistoryModal from "../../../components/appointment-status-history/appointment-status-history-modal"; // New import for status history modal

import api from "../../../API/api";
import { DownloadTableExcel } from "react-export-table-to-excel";
import {
  Badge,
  IconButton,
  MenuItem,
  Stack,
  TablePagination,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import CustomizedMenus from "../../../components/tools/menu";
import useDebounce from "../../../hooks/use-debounce";
import TextFieldTableHead from "../../../components/table/textfield-table-head";
import DebounceSpinner from "../../../components/common/debounce-spinner";
import AccordionFilter from "../../../components/filter/accordion-filter";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#016b8b",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const HealthPackageAppointments = () => {
  const tableRef = useRef(null);
  const [getRow, setGetRow] = useState();
  const [appoinments, setAppoinments] = useState();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const [filters, setFilters] = useState({
    filter_status: "",
    page: 1,        // Add 1-based page to filters
    per_page: 5,    // Add per_page to filters
  });

  const viewAppointments = (newPage) => {
    api
      .GetAppointmentsForHealthPackage(
        { page: newPage + 1, per_page: rowsPerPage },  // Convert 0-based MUI to 1-based API
        1
      )
      .then((res) => {
        console.log("===>>>>", res);
        // setDepartment(res.data.data)
        setAppoinments(res.data.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  useEffect(() => {
    viewAppointments();
  }, []);

  // Fetch data when page or rowsPerPage changes
  useEffect(() => {
    viewAppointments(page);
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);  // Keep state 0-based for MUI
    setFilters({
      ...filters,
      page: newPage + 1  // Store 1-based in filters for API
    });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setFilters({
      ...filters,
      per_page: parseInt(event.target.value, 10),
      page: 1  // Reset to page 1 when changing rows per page
    });
    viewAppointments(0, event.target.value);
  };
  const handleStatus = (status, remarks) => {
    setUpdatingStatus(true);
    // Updated to accept remarks
    console.log(getRow, "getRow");
    const payload = {
      health_package_id:
        getRow.health_package_appointments[0].health_package_id,
      appointment_id: getRow.health_package_appointments[0].appointment_id,
      status: status,
      remarks, // Added remarks to payload
    };
    api
      .UpdateHealthPackageAppointmentStatus(payload)
      .then((res) => {
        console.log(res);
        viewAppointments();
        handleCloseModal();
        if (res.data.success) {
          Swal.fire({
            title: "Success!",
            text: "Status Updated",
            icon: "success",
            confirmButtonText: "Ok",
          });
          toast.success("Status Updated Successfully");
        }
      })
      .catch((err) => {
        if (err.response.data.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Something went wrong!");
        }
      })
      .finally(() => {
        setUpdatingStatus(false);
        setModalProps({});
      });
  };

  const menuButtons = [
    {
      id: 1,
      name: "Confirmed",
      onClick: (remarks) => handleStatus("confirmed", remarks), // Updated to include remarks
    },
    {
      id: 2,
      name: "Cancelled",
      onClick: (remarks) => handleStatus("cancelled", remarks), // Updated to include remarks
    },
    {
      id: 3,
      name: "Completed",
      onClick: (remarks) => handleStatus("completed", remarks), // Updated to include remarks
    },
    {
      id: 4,
      name: "Unable to reach",
      onClick: (remarks) => handleStatus("Unable_to_reach", remarks),
    },
  ];
  const getStatusColor = (status) => {
    switch (status) {
      case "requested":
        return "primary";
      case "confirmed":
        return "success";
      case "completed":
        return "warning";
      case "cancelled":
        return "error";
      case "Unable_to_reach":
        return "info";
      default:
        return "default";
    }
  };

  const viewAppointmentsByFilters = () => {
    // Use current filter values for page and per_page instead of hardcoded
    let newFilters = { ...filters };
    Object.keys(newFilters).forEach((key) => {
      if (newFilters[key] === "") {
        delete newFilters[key];
      }
    });

    api
      .GetAppointmentsForHealthPackage(
        { page: filters.page || 1, per_page: filters.per_page || 5 },  // Use filters values
        1,
        null,
        newFilters
      )
      .then((res) => {
        console.log("===>>>>", res);
        // setDepartment(res.data.data)
        setAppoinments(res.data.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const [debouncedViewAppointmentsByFilter, isDebouncing] = useDebounce(
    viewAppointmentsByFilters,
    300
  );

  useEffect(() => {
    debouncedViewAppointmentsByFilter();
  }, [filters]);

  const {
    openModal,
    modalProps,
    updatingStatus,
    setUpdatingStatus,
    statusHistoryModal,
    statusHistoryModalData,
    setStatusHistoryModalData,
    handleOpenStatusHistoryModal,
    handleCloseStatusHistoryModal,
    setModalProps,
    handleOpenModal,
    handleCloseModal,
  } = useMenuModalStates(); // New hook for modal states

  // status badge clic
  // will open a modal with a table
  const handleStatusBadgeClick = (row) => {
    setGetRow(row);
    setStatusHistoryModalData(row);
    handleOpenStatusHistoryModal();
  };

  return (
    <>
      <h6>Health Package appoinments </h6>
      <AccordionFilter
        filterOptions={{
          from: {
            id: "from",
            label: "From",
            type: "date",
          },
          to: {
            id: "to",
            label: "To",
            type: "date",
          },
        }}
        filters={filters}
        setFilters={setFilters}
        onFilterChange={debouncedViewAppointmentsByFilter}
      ></AccordionFilter>
      <TableContainer component={Paper} ref={tableRef}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>ID</StyledTableCell>
              <StyledTableCell align="center">
                <TextFieldTableHead
                  title={"Patient Name"}
                  type={"text"}
                  onChange={(e) => {
                    setFilters({ ...filters, patient_name: e.target.value });
                  }}
                ></TextFieldTableHead>
              </StyledTableCell>
              <StyledTableCell align="center">Phone No.</StyledTableCell>
              <StyledTableCell align="center">Gender</StyledTableCell>
              <StyledTableCell align="center">Age</StyledTableCell>
              <StyledTableCell align="center">City</StyledTableCell>
              <StyledTableCell align="center">Generated At</StyledTableCell>
              <StyledTableCell align="center">Appoin. Date</StyledTableCell>
              {/* <StyledTableCell align="center">For Doctor</StyledTableCell> */}
              <StyledTableCell align="center">Last Updated By</StyledTableCell>
              <StyledTableCell align="center">
                <StyledTableCell align="center">
                  <TextField
                    select
                    label="Status"
                    value={filters.filter_status}
                    onChange={(e) =>
                      setFilters({ ...filters, filter_status: e.target.value })
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "white",
                        },
                        "&:hover fieldset": {
                          borderColor: "white",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "white",
                        },
                        color: "white", // Text color for the select
                      },
                      "& .MuiInputLabel-root": {
                        color: "white",
                      },
                      "& .MuiSelect-root": {
                        color: "white",
                      },
                      "& .MuiSelect-icon": {
                        color: "white", // Dropdown icon color
                      },
                      "& .MuiMenuItem-root": {
                        color: "white", // Text color for menu items
                      },
                      minWidth: 150,
                      color: "white", // Text color for the TextField
                    }}
                    InputLabelProps={{
                      style: { color: "white" }, // Ensure label is white even when focused
                    }}
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            bgcolor: "rgba(0, 0, 0, 0.9)", // Dark background for dropdown
                            "& .MuiMenuItem-root": {
                              color: "white", // Ensure menu items are white
                            },
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="requested">Requested</MenuItem>
                    <MenuItem value="confirmed">Confirmed</MenuItem>
                    <MenuItem value="completed">Completed</MenuItem>
                    <MenuItem value="cancelled">Cancelled</MenuItem>
                  </TextField>
                </StyledTableCell>
              </StyledTableCell>
              <StyledTableCell align="center">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isDebouncing && <DebounceSpinner isDebouncing={isDebouncing} />}
            {!isDebouncing &&
              appoinments &&
              appoinments?.data?.map((row, index) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell component="th" scope="row">
                    {index + 1}
                  </StyledTableCell>
                  <StyledTableCell align="center">{row.name}</StyledTableCell>
                  <StyledTableCell align="center">{row.phone}</StyledTableCell>
                  <StyledTableCell align="center">{row.gender}</StyledTableCell>
                  <StyledTableCell align="center">{row.age}</StyledTableCell>
                  <StyledTableCell align="center">{row.city}</StyledTableCell>
                  <StyledTableCell align="center">
                    {new Date(row.created_at).getDate() +
                      ", " +
                      new Date(row.created_at).toLocaleString("default", {
                        month: "long",
                      }) +
                      "-" +
                      new Date(row.created_at).getFullYear()}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {new Date(
                      row.health_package_appointments[0].date
                    ).getDate() +
                      ", " +
                      new Date(
                        row.health_package_appointments[0].date
                      ).toLocaleString("default", {
                        month: "long",
                      }) +
                      "-" +
                      new Date(
                        row.health_package_appointments[0].date
                      ).getFullYear()}
                  </StyledTableCell>

                  <StyledTableCell align="center">
                    {row.last_updated_by && row.last_updated_by.length > 0 ? (
                      <Stack direction={"column"}>
                        <Typography variant="body2" color="text.secondary">
                          {/* <img  height="40px" src={`${process.env.REACT_APP_BACKEND_USER}/${row?.last_updated_by[0].id}/${row?.last_updated_by[0].image}`} /> */}
                          {
                            row.last_updated_by.length > 0 ?
                              <img height="40px" src={`${process.env.REACT_APP_BACKEND_USER}/${row?.last_updated_by[row.last_updated_by.length - 1].id}/${row?.last_updated_by[row.last_updated_by.length - 1].image}`} />
                              :
                              <img height="40px" src={`${process.env.REACT_APP_BACKEND_USER}/${row?.last_updated_by[0].id}/${row?.last_updated_by[0].image}`} />
                          }
                          {
                            row.last_updated_by.length > 0 ?
                              row.last_updated_by[row.last_updated_by.length - 1].name
                              :
                              row.last_updated_by[0].name

                          }
                        </Typography>
                        <Typography variant="body2">
                          {
                            row.last_updated_by.length > 0 ?
                              row.last_updated_by[row.last_updated_by.length - 1].email
                              :
                              row.last_updated_by[0].email

                          }
                        </Typography>
                        <Typography variant="body2">
                          {row.last_updated_by[0].email}
                        </Typography>
                      </Stack>
                    ) : (
                      "null"
                    )}
                  </StyledTableCell>
                  {/* <StyledTableCell align="center">
                    {row.doctors[0].name}
                  </StyledTableCell> */}
                  <StyledTableCell align="center">
                    <Tooltip title="Click to view the history" arrow>
                      <IconButton onClick={() => handleStatusBadgeClick(row)}>
                        <Badge
                          badgeContent={row.status}
                          color={getStatusColor(row.status)}
                          anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        ></Badge>
                      </IconButton>
                    </Tooltip>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <CustomizedMenus
                      opensModal={true}
                      setModalProps={setModalProps}
                      handleOpenModal={handleOpenModal}
                      openModal={openModal}
                      row={row}
                      menuButtons={menuButtons}
                      setGetRow={setGetRow}
                      btnText={"update status"}
                    />
                  </StyledTableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={appoinments?.total}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <MenuModal
        updatingStatus={updatingStatus}
        handleOpen={handleOpenModal}
        handleClose={handleCloseModal}
        open={openModal}
        status={modalProps.status}
        handleClick={modalProps.onClick}
        setModalProps={setModalProps}
      />
      <AppointmentStatusHistoryModal
        open={statusHistoryModal}
        handleClose={handleCloseStatusHistoryModal}
        data={statusHistoryModalData}
        setStatusHistoryModalData={setStatusHistoryModalData}
        getAppointmentHistoryFromServer={api.healthPackageAppointmentHistory} // Adjusted API call
        historyFor="health_packages" // Adjusted history type
      />
    </>
  );
};

export default HealthPackageAppointments;
